import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../assets/CustomTableStyles";
import { get, post } from "../../services/api";
import { toast } from "react-toastify";
import Select from "react-select";

function PerformanceEvaluation() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : Number(localStorage.getItem("centerId"));

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
    getValues,
  } = useForm({
    defaultValues: {
      id: 0,
      createdBy: localStorage.getItem("userId"),
      organizationId: localStorage.getItem("organizationId"),
      evaluationCriteriaTypeId: "",
      sectionSubjectId: "",
      classSectionId: "",
      studentId: "",
      classTeacherComments: "",
      schoolHeadComments: "",
      isPromoted: false,
      // sessionId: 0,
      code: "",
      performanceEvaluationMarkDetails: [
        // {
        //   id: 0,
        //   subjectClassEvaluationCriteriaId: 0,
        //   subjectClassEvaluationCriteria: "string",
        //   studentAchievementRatingId: 0,
        //   studentAchievementRating: "string",
        //   performanceEvaluationMarkId: 0,
        //   sectionSubjectId: 0,
        //   comments: "string",
        // },
      ],
    },
  });

  const [triggerRerender, setTriggerRerender] = useState(false);
  const [centerId, setCenterId] = useState(savedCenterId || null);

  const [evaluationCriteriaTypeId, setEvaluationCriteriaTypeId] =
    useState(null);
  const [classSectionId, setClassSectionId] = useState(null);
  const [sectionSubjectId, setSectionSubjectId] = useState(null);
  const [studentId, setStudentId] = useState(null);

  const [termsData, setTermsData] = useState([]);
  const [classSectionsData, setClassSectionsData] = useState([]);
  const [subjectsData, setSubjectsData] = useState([]);
  const [studentsData, setStudentsData] = useState([]);

  const [evaluationTableData, setEvaluationTableData] = useState([]);
  const [ratingOptionsData, setRatingOptionsData] = useState([]);
  const [ratingOption, setRatingOption] = useState("");

  const fetchTermsByOrgId = async () => {
    try {
      const response = await get(
        `StudentEvaluation/GetAllEvaluationCriteriaType?OrganizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTermsData(response?.evaluationTypes);
    } catch (error) {
      console.error("Error fetching terms:", error);
    }
  };

  useEffect(() => {
    fetchTermsByOrgId();
  }, []);

  const fetchClassSectionsByCenterId = async (centerId) => {
    try {
      if (centerId) {
        const response = await get(
          `ClassSection/GetAllClassSectionByCenterId?centerId=${centerId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setClassSectionsData(response);
      } else {
        setClassSectionsData([]);
      }
    } catch (error) {
      console.error("Error fetching classes:", error);
    }
  };

  useEffect(() => {
    fetchClassSectionsByCenterId(centerId);
  }, [centerId]);

  const fetchSubjectsByClassSectionId = async (classSectionId) => {
    try {
      const response = await get(
        `StudentEvaluation/GetSubjectByClassSectionId?ClassSectionId=${classSectionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSubjectsData(response.subjects || []); // Update subjects state
    } catch (error) {
      console.error("Error fetching subjects:", error);
    }
  };

  useEffect(() => {
    if (classSectionId) {
      fetchSubjectsByClassSectionId(classSectionId);
    } else {
      setSubjectsData([]);
    }
  }, [classSectionId]);

  const fetchStudentsByIds = async (classSectionId, sectionSubjectId) => {
    try {
      const response = await get(
        `StudentEvaluation/GetStudentByClassSectionIdAndSubjectId?ClassSectionId=${classSectionId}&SectionSubjectId=${sectionSubjectId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setStudentsData(response?.students || []);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  useEffect(() => {
    if (classSectionId && sectionSubjectId) {
      fetchStudentsByIds(classSectionId, sectionSubjectId);
    } else {
      setStudentsData([]);
    }
  }, [classSectionId, sectionSubjectId]);

  const handleTermChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "clear") {
      setEvaluationCriteriaTypeId(null);
      setClassSectionId(null);
      setSectionSubjectId(null);
      setStudentId(null);

      setClassSectionsData([]);
      setSubjectsData([]);
      setStudentsData([]);

      setValue("evaluationCriteriaTypeId", null);
      setValue("classSectionId", null);
      setValue("sectionSubjectId", null);
      setValue("studentId", null);
    } else {
      setEvaluationCriteriaTypeId(selectedOption ? selectedOption.value : null);
      setValue("evaluationCriteriaTypeId", selectedOption);
    }
  };

  const handleClassSectionChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "clear") {
      setClassSectionId(null);
      setSectionSubjectId(null);
      setStudentId(null);

      setSubjectsData([]);
      setStudentsData([]);

      setValue("classSectionId", null);
      setValue("sectionSubjectId", null);
      setValue("studentId", null);
    } else {
      setClassSectionId(selectedOption ? selectedOption.value : null);
      setValue("classSectionId", selectedOption);
    }
  };

  const handleSubjectChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "clear") {
      setSectionSubjectId(null);
      setStudentId(null);

      setStudentsData([]);

      setValue("sectionSubjectId", null);
      setValue("studentId", null);
    } else {
      setSectionSubjectId(selectedOption ? selectedOption.value : null);
      setValue("sectionSubjectId", selectedOption);
    }
  };

  const handleStudentChange = (selectedOption, actionMeta) => {
    if (actionMeta.action === "clear") {
      setStudentId(null);

      setEvaluationTableData([]);

      setValue("studentId", null);
    } else {
      setStudentId(selectedOption ? selectedOption.value : null);
      setValue("studentId", selectedOption);
    }
  };

  const handleRateAllDropdown = (event) => {
    const selectedRatingOption = event.target.value;
    setRatingOption(selectedRatingOption);
  };

  const fetchAcheivementRating = async () => {
    try {
      const response = await get(
        `StudentEvaluation/GetAllAcheivementRating?organizationId=${organizationId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setRatingOptionsData(response?.acheivementRatings);
    } catch (error) {
      console.error("Error fetching rating options:", error);
    }
  };

  useEffect(() => {
    fetchAcheivementRating();
  }, []);

  // const ratingOptionsData = [
  //   {
  //     id: "A",
  //     name: "A",
  //   },
  //   {
  //     id: "B",
  //     name: "B",
  //   },
  //   {
  //     id: "C",
  //     name: "C",
  //   },
  // ];

  const fetchEvaluationData = async (
    evaluationCriteriaTypeId,
    classSectionId,
    sectionSubjectId,
    studentId
  ) => {
    try {
      const response = await get(
        `StudentEvaluation/GetPerformanceEvaluationMarks?evaluationCriteriaTypeId=${evaluationCriteriaTypeId}&classSectionId=${classSectionId}&sectionSubjectId=${sectionSubjectId}&studentId=${studentId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        const performanceData =
          response?.performanceEvaluation?.performanceEvaluationMarkDetails ||
          [];

        const transformedData =
          mapResponseToPerformanceDetails(performanceData);

        // Populate other fields from the response
        const evaluationDetails = {
          id: response.performanceEvaluation.id || 0,
          evaluationCriteriaTypeId:
            response.performanceEvaluation.evaluationCriteriaTypeId || 0,
          studentId: response.performanceEvaluation.studentId || 0,
          classTeacherComments:
            response.performanceEvaluation.classTeacherComments || "",
          isPromoted: response.performanceEvaluation.isPromoted || false,
          organizationId: response.performanceEvaluation.organizationId || 0,
          classSectionId: response.performanceEvaluation.classSectionId || 0,
          sectionSubjectId:
            response.performanceEvaluation.sectionSubjectId || 0,
          schoolHeadComments:
            response.performanceEvaluation.schoolHeadComments || "",
          sessionId: response.performanceEvaluation.sessionId || 0,
          performanceEvaluationMarkDetails: transformedData,
        };

        setValue("id", response.performanceEvaluation.id || 0);
        setValue(
          "classTeacherComments",
          response.performanceEvaluation.classTeacherComments || ""
        );
        setValue(
          "isPromoted",
          response.performanceEvaluation.isPromoted || false
        );
        setValue(
          "schoolHeadComments",
          response.performanceEvaluation.schoolHeadComments || ""
        );
        setValue("performanceEvaluationMarkDetails", transformedData);

        // reset(evaluationDetails);

        console.log(transformedData);

        setEvaluationTableData(transformedData);
      } else {
        console.error(
          "Error fetching evaluation: Response was not successful."
        );
      }
    } catch (error) {
      console.error("Error fetching evaluation:", error);
    }
  };

  useEffect(() => {
    if (
      evaluationCriteriaTypeId &&
      classSectionId &&
      sectionSubjectId &&
      studentId
    ) {
      fetchEvaluationData(
        evaluationCriteriaTypeId,
        classSectionId,
        sectionSubjectId,
        studentId
      );
    } else {
      setEvaluationTableData([]);
    }
  }, [evaluationCriteriaTypeId, classSectionId, sectionSubjectId, studentId]);

  const mapResponseToPerformanceDetails = (data) => {
    return data.map((item) => ({
      id: item.id || 0,
      subjectClassEvaluationCriteriaId:
        item.subjectClassEvaluationCriteriaId || 0,
      performanceEvaluationMarkId: item.performanceEvaluationMarkId || 0,
      studentAchievementRatingId: item.studentAchievementRatingId || 0,
      studentAchievementRating: item.studentAchievementRating || "",
      sectionSubjectId: item.sectionSubjectId || 0,
      comments: item.comments || "",
      subjectClassEvaluationCriteria: item.subjectClassEvaluationCriteria || "",
      subjectClassItemHead: item.subjectClassItemHead || "",
    }));
  };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const formdata = {
      ...data,
      evaluationCriteriaTypeId: data.evaluationCriteriaTypeId.value,
      classSectionId: data.classSectionId.value,
      sectionSubjectId: data.sectionSubjectId.value,
      studentId: data.studentId.value,
      isPromoted: data.isPromoted ? true : false,
      performanceEvaluationMarkDetails:
        data.performanceEvaluationMarkDetails.map((detail) => ({
          id: detail.id,
          subjectClassEvaluationCriteriaId:
            detail.subjectClassEvaluationCriteriaId,
          performanceEvaluationMarkId: detail.performanceEvaluationMarkId,
          studentAchievementRatingId: detail.studentAchievementRatingId,
          studentAchievementRating: detail.studentAchievementRating || "",
          sectionSubjectId: detail.sectionSubjectId,
          comments: detail.comments || "",
          subjectClassEvaluationCriteria:
            detail.subjectClassEvaluationCriteria || "",
          subjectClassItemHead: detail.subjectClassItemHead || "",
        })),
    };

    // console.log(formdata);
    // return;

    try {
      const response = await post(
        `StudentEvaluation/AddUpdatePerformanceEvaluationMarks`,
        formdata,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        // setTriggerRerender((prev) => !prev);
      }
    } catch (error) {
      console.error("Error saving subcategory:", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Performance Evaluation</h2>
      </div>

      <form className="row g-3" onSubmit={handleSubmit(saveData)}>
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex mb-2">
                <h4 className="fs-8 text-secondary">Select Pupil</h4>
              </div>
              <div className="row g-3">
                <div className="col-md-3">
                  <label className="form-label">
                    Term<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`evaluationCriteriaTypeId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={termsData.map((term) => ({
                          value: term.id,
                          label: term.type,
                        }))}
                        onChange={handleTermChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        // isClearable
                      />
                    )}
                  />
                  {errors.evaluationCriteriaTypeId && (
                    <small className="text-danger">
                      {errors.evaluationCriteriaTypeId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-3">
                  <label className="form-label">
                    Year Group - Section
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="classSectionId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={classSectionsData.map((classSection) => ({
                          value: classSection.id,
                          label: classSection.name,
                        }))}
                        onChange={handleClassSectionChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.classSectionId && (
                    <small className="text-danger">
                      {errors.classSectionId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-3">
                  <label className="form-label">
                    Subject<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`sectionSubjectId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={subjectsData.map((subject) => ({
                          value: subject.id,
                          label: subject.name,
                        }))}
                        onChange={handleSubjectChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.sectionSubjectId && (
                    <small className="text-danger">
                      {errors.sectionSubjectId.message}
                    </small>
                  )}
                </div>
                <div className="col-md-3">
                  <label className="form-label">
                    Pupil<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name={`studentId`}
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={studentsData.map((student) => ({
                          value: student.id,
                          label: student.name,
                        }))}
                        onChange={handleStudentChange}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.studentId && (
                    <small className="text-danger">
                      {errors.studentId.message}
                    </small>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex mb-2">
                <h4 className="fs-8 text-secondary">Evaluate Performance</h4>
                <div
                  className="d-flex justify-content-end ms-auto d-none"
                  style={{ marginTop: 0 }}
                >
                  <div className="d-flex align-items-center">
                    <label className="form-label me-2 mb-0">Rate All</label>
                    <select
                      className="form-select"
                      value={ratingOption}
                      onChange={handleRateAllDropdown}
                      style={{ width: "120px" }}
                    >
                      <option value="0" key={"center-key"}>
                        Select
                      </option>
                      {ratingOptionsData.map((rating) => (
                        <option key={rating.id} value={rating.id}>
                          {rating.code}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <table className="table table-bordered custom-table m-0">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Performance Activity</th>
                    <th>Item Heads</th>
                    <th>Rating</th>
                    <th>Comments</th>
                  </tr>
                </thead>
                <tbody>
                  {evaluationTableData.length > 0 ? (
                    evaluationTableData.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.subjectClassEvaluationCriteria}</td>
                        <td>{item.subjectClassItemHead}</td>
                        <td>
                          <select
                            className="form-select"
                            {...register(
                              `performanceEvaluationMarkDetails[${index}].studentAchievementRatingId`,
                              {
                                required: "This field is required", // Add the required validation rule
                              }
                            )}
                            defaultValue={item.studentAchievementRatingId || ""}
                          >
                            <option value="">Select</option>
                            {ratingOptionsData.map((rating) => (
                              <option key={rating.id} value={rating.id}>
                                {rating.code}
                              </option>
                            ))}
                          </select>
                          {errors.performanceEvaluationMarkDetails?.[index]
                            ?.studentAchievementRatingId && (
                            <div className="text-danger">
                              {
                                errors.performanceEvaluationMarkDetails[index]
                                  .studentAchievementRatingId.message
                              }
                            </div>
                          )}
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control"
                            {...register(
                              `performanceEvaluationMarkDetails[${index}].comments`
                            )}
                            defaultValue={item.comments || ""}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center">
                        There are no records to display
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex mb-2">
                <h4 className="fs-8 text-secondary">Enter Remarks</h4>
              </div>
              <div className="row g-3">
                <div className="col-md-3">
                  <label className="form-label">
                    Year Group Teacher's Remarks
                  </label>
                  <textarea
                    className="form-control"
                    {...register(`classTeacherComments`)}
                  ></textarea>
                </div>
                <div className="col-md-3">
                  <label className="form-label">School Head's Remarks</label>
                  <textarea
                    className="form-control"
                    {...register(`schoolHeadComments`)}
                  ></textarea>
                </div>
                <div className="col-md-2">
                  <div className="form-check form-check-inline">
                    <input
                      {...register("isPromoted")}
                      type="checkbox"
                      id="isPromoted"
                      value="isPromoted"
                      className="form-check-input"
                    />
                    <label className="form-check-label" htmlFor="isPromoted">
                      Is Promoted
                    </label>
                  </div>
                </div>
                {/* <div className="col-md-2">
                  <div className="form-check form-check-inline">
                    <input
                      {...register("isClassTeacher")}
                      type="checkbox"
                      id="isClassTeacher"
                      value="isClassTeacher"
                      className="form-check-input"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="isClassTeacher"
                    >
                      Is Class Teacher
                    </label>
                  </div>
                </div> */}
                <div className="col-12">
                  <button
                    className="btn btn-primary btn-sm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Save" : "Save"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}

export default PerformanceEvaluation;
